export default "__VITE_ASSET__JpYV2yxN__"